import { define } from '@owenscorning/pcb.alpha';

export default define`Paragraph`('0.0.1')({
  prepare: () => UI.Theme.Component('paragraph', 'p'),
});
